import { render, staticRenderFns } from "./ActionDelete.vue?vue&type=template&id=38369f04&"
import script from "./ActionDelete.vue?vue&type=script&lang=js&"
export * from "./ActionDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports